var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIvTrilogyDesktop(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 178,
    height: 186,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M113.852 0H135L22.148 413H0L113.852 0z",
    fill: "#ADDC9A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M134.852 0H156L43.148 413H22L134.852 0z",
    fill: "#6CC04A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M155.852 0H178L65.148 413H43L155.852 0z",
    fill: "#2C6D3C"
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTc4IiBoZWlnaHQ9IjE4NiIgdmlld0JveD0iMCAwIDE3OCAxODYiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGQ9Ik0xMTMuODUyIDBIMTM1TDIyLjE0ODIgNDEzSDBMMTEzLjg1MiAwWiIgZmlsbD0iI0FEREM5QSIvPgo8cGF0aCBkPSJNMTM0Ljg1MiAwSDE1Nkw0My4xNDgyIDQxM0gyMkwxMzQuODUyIDBaIiBmaWxsPSIjNkNDMDRBIi8+CjxwYXRoIGQ9Ik0xNTUuODUyIDBIMTc4TDY1LjE0ODIgNDEzSDQzTDE1NS44NTIgMFoiIGZpbGw9IiMyQzZEM0MiLz4KPC9zdmc+Cg==";
export { SvgIvTrilogyDesktop as ReactComponent };